import "./DriverBrandHeader.css";
import bigTaxiDriverLogo from "../../assets/big-taxi-driver-logo.png";
import BrandLogoContainer from "../../components/BrandLogoContainer";
import { getDriverLanguage, getDriverText } from "./driverI18n";

export default function DriverBrandHeader({
  brandName = "BIG TAXI",
  logoSrc = bigTaxiDriverLogo,
  actions = null,
  subtitle = "",
  children = null,
  driverName = "",
  onBack = null,
  pageTitle = "",
}) {
  const text = getDriverText(getDriverLanguage());
  return (
    <header className="driver-brand-header driver-brand-image-header">
      <div className="driver-brand-header-main">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="driver-brand-back-button"
            data-testid="back-button"
            aria-label={text.back}
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <BrandLogoContainer className="driver-brand-mark" src={logoSrc} alt={brandName} />
        <div className="driver-brand-copy">
          <h1 className="driver-brand-title-gold">{brandName}</h1>
          <p className="driver-brand-subtitle-white">{pageTitle || "Private Transfer & Charter"}</p>
          <p className="driver-brand-page-meta">
            {[driverName,subtitle].filter(Boolean).join(" · ") || "Driver Portal"}
          </p>
        </div>
        {actions && <div className="driver-brand-actions">{actions}</div>}
      </div>
      {children && <div className="driver-brand-toolbar">{children}</div>}
    </header>
  );
}
